import React from "react";
import styled from "styled-components";
import { Form, TertiaryButton } from "components";
import { HeaderTextColor, ParagraphTextColor, getGreeting } from "utils";
import "./styles.scss";
import { themed } from "components";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
// * State stuff
import { reducer } from "./reducer";
import { initialState } from "./constants";
import { actions } from "./actions";

// * Api stuff
import { callApi } from "api";

const Container = styled.div`
  .login__right {
    background-color: ${(props) => props.theme.headerHero.background};
  }
  .login__left h1 {
    border-bottom: 3px solid ${(props) => props.theme.borderText};
  }
`;
export default function LoginScreen() {
  const history = useHistory();
  const [state, dispatch] = React.useReducer(reducer, initialState);
  React.useEffect(() => {
    if (state.login.success || localStorage.getItem("userInfo")) {
      history.push("/dashboard");
      window.location.reload();
    }
  }, [state.login.loading, history, state.login.success]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch({
      type: actions.UPDATE_FORM_DATA,
      payload: {
        name,
        value,
      },
    });
  };
  const submitHandler = (e) => {
    e.preventDefault();
    toast.promise(
      callApi(
        "/api/users/login/",
        "POST",
        state.loginInfo,
        {
          REQUEST: actions.LOGIN_REQUEST,
          SUCCESS: actions.LOGIN_SUCCESS,
          FAILURE: actions.LOGIN_FAILURE,
        },
        dispatch
      ),
      {
        loading: "Iniciando sesión...",
        success: "Sesión iniciada correctamente",
        error: "Error al iniciar sesión",
      },
      {
        ...themed,
      }
    );
  };
  return (
    <Container className="login__container">
      <div className="login__left appear__from__bottom">
        <HeaderTextColor modifiers={["h3"]}>{getGreeting()}</HeaderTextColor>
        <ParagraphTextColor>
          Ingresa tus datos para iniciar sesión en el panel de administración.
        </ParagraphTextColor>
        <Form onSubmit={submitHandler}>
          <label for="username">Usuario</label>
          <input
            type="text"
            name="username"
            value={state.loginInfo.username}
            onChange={handleChange}
            required
          />
          <label for="password">Contraseña</label>
          <input
            type="password"
            name="password"
            value={state.loginInfo.password}
            onChange={handleChange}
            required
          />
          <TertiaryButton
            modifiers={["form", "autoWidth"]}
            disabled={
              state.login.loading ||
              state.loginInfo.password === "" ||
              state.loginInfo.username === ""
            }
          >
            Iniciar Sesión
          </TertiaryButton>
        </Form>
      </div>
      <div className="login__right"></div>
    </Container>
  );
}
